import React, {FunctionComponent} from 'react';
import { Link } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import ChallengeButton from '/src/ui/challengeProtocol/ChallengeButton';
import {useTranslation} from 'react-i18next';

const ChallengeBanner: FunctionComponent = () => {
    const classes = useStyles()
    const {t} = useTranslation()

    return (
        <div className={classes.root}>
            <Link underline="none" href="https://shop.s10.run/products/card-allrunnersmatter">
                <ChallengeButton protocolBanner>
                    {t('buyPostcard')}
                </ChallengeButton>
            </Link>
        </div>
    )
}


const useStyles = makeStyles({
    root: {
        height: '7rem',
        background: `no-repeat url(${require('../../assets/icons/ChallengeProtocolBanner.svg')})`,
        backgroundSize: 'cover',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    }
})

export default ChallengeBanner